import * as monaco from 'monaco-editor'

let monacoSetupDone = false
export function setupMonaco() {
  if (monacoSetupDone) return
  monacoSetupDone = true;
  const tables = ['mf_tracking_data_origin_record', 'mf_kafka_tracking_today']

  const fields = [
    'version', 'platform', 'appname', 'channel', 'traceid',
    'province', 'city', 't_location', 'location', 'ip', 't_timestamp',
    'user_id', 'user_data', 'user_nick', 'member', 'page',
    'device', 'type', 'custom_type', 'value_data_type', 'value',
    'add_time', 'module', 'item_id', 'sku_id',
    'ext_1', 'ext_2', 'ext_3', 'ext_4'
  ]

  const functions = [
    { label: 'COUNT', insertText: 'COUNT(${1:*})', doc: '统计数量' },
    { label: 'day_scope', insertText: "TO_CHAR(FROM_UNIXTIME(${1:timestamp} / 1000), '${2:yyyy-MM-dd}')", doc: '时间戳转日期字符串' },
    { label: 'TO_MILLIS', insertText: "TO_MILLIS(DATETIME '${1:2025-08-01 00:00:00}')", doc: '日期转时间戳' },
    { label: 'FROM_UNIXTIME', insertText: 'FROM_UNIXTIME(${1:timestamp} / 1000)', doc: '时间戳转时间' },
    { label: 'timeOnSite', insertText: "SUM(IF(${1:value} > 10 * 60 * 1000, 0, ${1:value})) as timeOnSite", doc: '计算停留时长（大于10分钟按0处理）' }
  ]

  const metrics = [
    { label: 'pv', insertText: 'COUNT(user_id) AS pv', doc: '页面浏览量（PV）' },
    { label: 'uv', insertText: 'COUNT(DISTINCT user_id) AS uv', doc: '独立访客数（UV）' }
  ]

  const keywords = [
    'SELECT', 'FROM', 'WHERE', 'GROUP BY', 'ORDER BY', 'HAVING',
    'JOIN', 'LEFT JOIN', 'INNER JOIN', 'UNION', 'DISTINCT'
  ]

  monaco.languages.registerCompletionItemProvider('sql', {
    provideCompletionItems: () => {
      const addedLabels = new Set()
      const suggestions = []

      function addSuggestion(label, kind, insertText, doc) {
        if (!addedLabels.has(label)) {
          suggestions.push({
            label,
            kind,
            insertText,
            insertTextRules: insertText.includes('${')
              ? monaco.languages.CompletionItemInsertTextRule.InsertAsSnippet
              : undefined,
            documentation: doc
          })
          addedLabels.add(label)
        }
      }

      // 关键字
      keywords.forEach(k => addSuggestion(k, monaco.languages.CompletionItemKind.Keyword, k))

      // 表名
      tables.forEach(t => addSuggestion(t, monaco.languages.CompletionItemKind.Struct, t, '表名'))

      // 字段
      fields.forEach(f => addSuggestion(f, monaco.languages.CompletionItemKind.Field, f, '字段'))

      // 函数
      functions.forEach(fn => addSuggestion(fn.label, monaco.languages.CompletionItemKind.Function, fn.insertText, fn.doc))

      // PV/UV
      metrics.forEach(m => addSuggestion(m.label, monaco.languages.CompletionItemKind.Snippet, m.insertText, m.doc))

      return { suggestions }
    }
  })
}